import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, List, Button } from 'antd'
import { HTMLText, Img, InfoRectangle } from '../components/common'
import Confetti from 'react-confetti'

import { StepsPage } from '../structure'
import { Cover } from '../components'
import { useUploadProcess } from '../context/UploadProcessProvider'
import Title from 'antd/lib/typography/Title'
import Paragraph from 'antd/lib/typography/Paragraph'
import { useParams } from 'react-router-dom'
import i18n from './../i18n'

const MY_DOCUMENT = '/login/#document/:submission_id'
const MY_PROFILE = '/login/#account/masterdata'

const Finish = () => {
  const { t } = useTranslation()
  const { data } = useUploadProcess()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <StepsPage
      step={3}
      className="finish"
      title={t('Finished.Congratulations')}
    >
      <InfoRectangle>
        <Row justify={'center'}>
          <Col xs={24} sm={16} xl={14}>
            <Img src="images/common/finish.webp" />
            <Title>{t('Finished.Congratulations')}</Title>
            <Title level={3}>{t('Finished.TextReady')}</Title>
            <br />
            <Paragraph className="paragraph-sb">
              {t('Finished.WhatHappensNext')}
            </Paragraph>
            <HTMLText html={t('Finished.PublicationStep1')} />
            <br />
            <HTMLText html={t('Finished.PublicationStep2')} />
          </Col>
          <Col sm={6} xl={8} className="show-on-desktop">
            <Cover
              author={data?.author}
              title={data?.title}
              hideHeaders={true}
            />
          </Col>
        </Row>
      </InfoRectangle>
      {/* <LinkWithPicture text={t('Finished.Options')} content={<Options />} /> */}
      <br className="show-on-mobile" />
      <br className="show-on-mobile" />
      <Links />
      <Confetti height={1400} numberOfPieces={1000} recycle={false} />
    </StepsPage>
  )
}

const Links = () => {
  const { t } = useTranslation()
  const params = useParams()
  const submission_id = parseInt(params.submission_id)
  return (
    <>
      <Row justify={'space-between'} gutter={{ sm: 0, xl: 90 }}>
        <Col xs={24} sm={18} xl={12}>
          <Title>{t('Finished.Account')}</Title>
          <Paragraph>
            {t('Finished.AccountDescription')}
            {(i18n.resolvedLanguage === 'en' ||
              i18n.resolvedLanguage === 'fr') && (
              <>
                <br />
                <br />
              </>
            )}
          </Paragraph>
          <Button
            type="primary"
            href={MY_DOCUMENT.replace(':submission_id', submission_id)}
            htmlType="submit"
          >
            {t('Finished.Account.button')}
          </Button>
          <hr />
        </Col>
        <Col xs={24} sm={18} xl={12}>
          <Title>{t('Finished.PersonalData')}</Title>
          <Paragraph>{t('Finished.PersonalDataDescription')}</Paragraph>
          <Button type="primary" htmlType="submit" href={MY_PROFILE}>
            {t('Finished.PersonalData.button')}
          </Button>
          <hr />
        </Col>
      </Row>
      <br />
      <br />
      <br />
    </>
  )
}

export default Finish
